import * as React from 'react';
import './_CustomPropertyActions.scss';
import { ICustomPropertyActionsProps } from './types';
import { CLASS_CUSTOM_PROPERTY_ITEM } from '../constants';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
import { Button, ButtonDropdown, Icon, SelectList, SelectListItem } from 'kui';
import { CUSTOM_ACTIONS, CUSTOM_HIDE, CUSTOM_PIN, CUSTOM_SHOW, CUSTOM_UNPIN } from './constants';
import { AsidePanelContext } from '../../../../../aside_panel/asidePanel/components/AsidePanel/constants';
import {
    ID_ASIDE_PANEL_PORTAL
} from '../../../../../aside_panel/asidePanel/components/AsidePanelActionsButton/constants';
import { getAsidePanelTooltip } from '../../../../../aside_panel/asidePanel/helpers/getAsidePanelTooltip';
import { CustomPropertiesPushToGoogleCalendarHOC } from '../../hocs/CustomPropertiesPushToGoogleCalendarHOC/CustomPropertiesPushToGoogleCalendarHOC';
import { ECustomPropertyType } from '../../../../../../../store/customProperties/types';

//@ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardCustomPropertyActions`) : null;

export function CustomPropertyActions ({
    id,
    cardId,
    isPinned,
    isPushToCalendar,
    // isShowEmpty,
    onTogglePin,
    // onToggleShowEmpty,
}: ICustomPropertyActionsProps) {
    if (analyzeRender) analyzeRender.call(`CardCustomPropertyActions ${cardId}`);

    const className = CLASS_CUSTOM_PROPERTY_ITEM + '-actions';

    const [isOpen, setOpen] = React.useState(null);

    const onActionClick = (action: () => void) => {
        action();
        setOpen(false);
    };

    return <ButtonDropdown
        className={className}
        opened={isOpen}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        directionHorizontal={'right'}
        directionVertical={'auto'}
        portal
        portalId={ID_ASIDE_PANEL_PORTAL}
    >
        <Button
            tooltip={getAsidePanelTooltip({
                value: CUSTOM_ACTIONS
            })}
            variant={'icon'}
        >
            <Icon size={24} xlink={'more'} />
        </Button>
        <SelectList fixActive={false}>
            {/*<SelectListItem*/}
            {/*    icon={'eye'}*/}
            {/*    onClick={() => onActionClick(onToggleShowEmpty)}*/}
            {/*    iconSize={24}*/}
            {/*>*/}
            {/*    {isShowEmpty ? CUSTOM_HIDE : CUSTOM_SHOW}*/}
            {/*</SelectListItem>*/}
            <SelectListItem
                icon={'pin'}
                onClick={() => onActionClick(onTogglePin)}
                iconSize={24}
            >
                {isPinned ? CUSTOM_UNPIN : CUSTOM_PIN}
            </SelectListItem>
            {isPushToCalendar &&
                <CustomPropertiesPushToGoogleCalendarHOC cardId={cardId} id={id} isSelectItem/>
            }
        </SelectList>
    </ButtonDropdown>;
};
